export enum DeliveryCompany {
  CDEK = 'cdek',
  BAIKAL = 'baikal'
}
